import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { Carousel } from 'antd'
import { createStyles } from 'antd-style'

import { queryBannerListApi } from '@eastcoal/api/content/bannerMall/queryBannerList'

import { DeviceType } from '@eastcoal/shared/enums/DeviceType'

import { BannerBlockProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  carousel: {
    fontSize: 0,
    backgroundColor: token.colorPrimaryBg
  },
  bg: {
    width: '100%',
    height: '100%',
    backgroundSize: '6000px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center'
  },
  img: {
    position: 'relative',
    width: token.layoutContentWidth,
    height: 380,
    margin: 'auto',
    objectFit: 'cover',
    zIndex: 1
  }
}))

export const BannerCarousel = ({
  className,
  classNames: externalClassNames,
  styles: externalStyles,
  pageName,
  pagePosition
}: BannerBlockProps) => {
  const { cx, styles } = useStyles()

  const { data } = useRequest(
    () =>
      queryBannerListApi(
        {
          pageName,
          pagePosition,
          device: DeviceType.PC
        },
        { silence: true }
      ),
    {
      manual: false,
      retryCount: 3,
      retryInterval: 200
    }
  )

  const bannerItems = useMemo(() => {
    const banners = data?.filter(item => !!item.accessUrl)
    return banners?.length ? (
      banners.map(({ id, accessUrl, navigateUrl, bgUrl }) => (
        <a key={id} href={navigateUrl} rel='noreferrer' target='_blank'>
          <div
            className={styles.bg}
            style={{
              backgroundImage: `url(${bgUrl})`
            }}
          >
            <img
              alt='banner'
              className={cx(styles.img, externalClassNames?.image)}
              src={accessUrl}
              style={externalStyles?.image}
            />
          </div>
        </a>
      ))
    ) : (
      <div
        className={cx(styles.img, externalClassNames?.image)}
        style={externalStyles?.image}
      />
    )
  }, [
    cx,
    data,
    externalClassNames?.image,
    externalStyles?.image,
    styles.bg,
    styles.img
  ])

  return (
    <Carousel
      arrows
      autoplay
      fade
      pauseOnHover
      autoplaySpeed={5000}
      className={cx(styles.carousel, className, externalClassNames?.carousel)}
      speed={1000}
      style={externalStyles?.carousel}
    >
      {bannerItems}
    </Carousel>
  )
}
